import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

import { globalContext } from "../../Context/globalContext";
import useConsult from "../../Firebase/Hooks/useConsult.js";

import Tabla from "../../Components/Tabala";

const headCells = [
  {
    id: "nombre",
    numeric: false,
    disablePadding: true,
    label: "Nombre",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Correo",
  },
  {
    id: "estado",
    numeric: false,
    disablePadding: false,
    label: "Estado",
  },
  {
    id: "acciones",
    numeric: false,
    disablePadding: false,
    label: "Acciones",
  },
];

const Mensajes = () => {
  const { setTitle } = useContext(globalContext);
  setTitle("Mensajes");

  const {
    collection: { mensajesPremios },
  } = useSelector((state) => state.firestore);

  useConsult([
    {
      consulta: "obtenerRealTime",
      collectionName: "mensajesPremios",
      // condicionWhere: ["estado", "==", false],
    },
  ]);

  const [notificacionMensaje, setNotificacionMensaje] = useState(false);

  // creamos una notificacion
  // TODO: perzonalizar la notificacion
  const sendNotification = () => {
    console.log("notificacion");
    new Notification("Nuevo mensaje", {
      body: "Ha llegado un nuevo mensaje de contacto",
    });
  };

  useEffect(() => {
    console.log({ notificacionMensaje, mensajesPremios });
    if (mensajesPremios && notificacionMensaje) {
      console.log("entro");
      // TODO: agregar validacion en ssessionStorage para que no se repita esta notificacion
      if (!("Notification" in window)) {
        console.log("no se puede");
        Swal.fire({
          title: "Error",
          text: "Tu navegador no es compatible con las notificaciones",
          confirmButtonColor: "#2DCD22",
          confirmButtonText: "Continuar",
          icon: "error",
        });
      } else if (Notification.permission === "granted") {
        console.log("notificacion");
        if (mensajesPremios.docs.length > notificacionMensaje) {
          sendNotification();
          setNotificacionMensaje(mensajesPremios.docs.length);
        }
      } else {
        console.log("permiso");
        Notification.requestPermission();
      }
    } else if (mensajesPremios) {
      console.log("no entro");
      setNotificacionMensaje(mensajesPremios.docs.length);
    }
    // eslint-disable-next-line
  }, [mensajesPremios, notificacionMensaje]);

  return (
    <div name="collection" className="contenedor-1">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p className="titulo-1">Todos los Mensajes</p>
      </div>

      {mensajesPremios && (
        <div style={{ marginBottom: "80px" }}>
          <Tabla
            collectionData={{
              collection: mensajesPremios.docs,
              headCells,
              verPrincipal: true,
              urlPrincipal: "mensaje",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Mensajes;
